export const selectStyles = {
  singleValue: (base: any) => ({ ...base, textAlign: 'left' as const }),
  placeholder: (base: any) => ({ ...base, textAlign: 'left' as const }),
  input: (base: any) => ({ ...base, textAlign: 'left' as const }),
  option: (base: any) => ({ ...base, textAlign: 'left' as const }),
};
